module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Reading the Gospels with Karl Barth")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb-001"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_vm._v("CD")])]), _vm._v(" "), _c('td', [_vm._v("Karl Barth, "), _c('i', [_vm._v("Church Dogmatics")]), _vm._v(", 4 vols. in 13 parts, trans. G. W. Bromiley and T. F. Torrance (Edinburgh: T. & T. Clark, 1936–1975)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("KD")])]), _vm._v(" "), _c('td', [_vm._v("Karl Barth, "), _c('i', [_vm._v("Kirchliche Dogmatik")]), _vm._v(", 4 vols. in 13 parts (Zollikon-Zürich: Evangelischer Verlag, 1932–1967)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KJV")]), _vm._v(" "), _c('td', [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NRSV")]), _vm._v(" "), _c('td', [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("WW")])]), _vm._v(" "), _c('td', [_vm._v("Karl Barth, "), _c('i', [_vm._v("Witness to the Word: A Commentary on John 1; Lectures at Münster in 1925 and at Bonn in 1933")]), _vm._v(", ed. Walther Fürst, trans. Geoffrey W. Bromiley (Grand Rapids: Eerdmans, 1986)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283c293a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 72
// module chunks = 0